import { render } from "./SyncWithGWSView.vue?vue&type=template&id=5a657755&scoped=true&ts=true"
import script from "./SyncWithGWSView.vue?vue&type=script&lang=ts"
export * from "./SyncWithGWSView.vue?vue&type=script&lang=ts"

import "./SyncWithGWSView.vue?vue&type=style&index=0&id=5a657755&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a657755"]])

export default __exports__